import NiceModal from '@ebay/nice-modal-react';
import CampaignDrawer from '@/components/Campaigns/CampaignDrawer';
import ContactDrawer from '@/components/Contacts/ContactDrawer';
import ContactFormDrawer from '@/components/Contacts/ContactFormDrawer';
import AddAccountModal from '../Account/AddAccountModal';
import AgentDrawer from '../Agents/AgentDrawer';
import CalendarDrawer from '../Calendars/CalendarDrawer';
import CallDrawer from '../Calls/CallDrawer';
import RunCampaignModal from '../Campaigns/RunCampaignModal';
import ContactListDrawer from '../ContactList/ContactListDrawer';
import DocumentDrawer from '../Documents/DocumentDrawer';
import PurchasePhoneNumberModal from '../PhoneNumbers/PurchasePhoneNumberModal';
import ScenarioDrawer from '../Scenarios/ScenarioDrawer';
import TeamMemberDrawer from '../Team/TeamMemberDrawer';
import WebhookDrawer from '../Webhooks/WebhookDrawer';

NiceModal.register('add-account-modal', AddAccountModal);
NiceModal.register('run-campaign-modal', RunCampaignModal);
NiceModal.register('purchase-phone-number-modal', PurchasePhoneNumberModal);
NiceModal.register('agent-drawer', AgentDrawer);
NiceModal.register('scenario-drawer', ScenarioDrawer);
NiceModal.register('call-drawer', CallDrawer);
NiceModal.register('webhook-drawer', WebhookDrawer);
NiceModal.register('show-contact-drawer', ContactDrawer);
NiceModal.register('contact-form-drawer', ContactFormDrawer);
NiceModal.register('team-member-drawer', TeamMemberDrawer);
NiceModal.register('campaign-drawer', CampaignDrawer);
NiceModal.register('document-drawer', DocumentDrawer);
NiceModal.register('calendar-drawer', CalendarDrawer);
NiceModal.register('contact-list-drawer', ContactListDrawer);

const ModalRegistration = () => {
  return <></>;
};

export default ModalRegistration;
